import useLocales from '../hooks/useLocales';

const Execute = (value: string): string => {
  const { translate } = useLocales();

  return translate(value);
};

export { Execute as translate };
